/**
 * Created by supun on 10/03/18.
 */
import { Auth } from 'aws-amplify';
import { put, takeEvery, call } from 'redux-saga/effects';
import { REDUX_API_GATEWAY_ACTIONS } from '../../constants/apiGateWayConstant';
import metadata from './metadata';
/* eslint no-unused-vars:0 */

import api from './api';

/**
 * Perform a socket send based on the meta data available corresponding to the request type
 *
 * @param {string} key - ws event key determine correct meta data
 * @param {string} payload - payload to be sent by ws client
 */
function apiGateWayHandler({ key, payload }) {
  // logger.info("apiGatewayHandler");
  // logger.info(key)
  const {
    method, endPoint, apiRoute, failureAction, successAction,
  } = metadata[key];

  return Auth.currentSession().then((idToken) => {
    const token = idToken.idToken.jwtToken;
    return Auth.currentCredentials().then((info) => {
      const identityId = info._identityId;
      return api(method, endPoint, apiRoute, failureAction, successAction, token, payload, identityId);
    });
  });
}

/**
 * Saga Side-Effects Handler
 * @param {object} action - redux action
 */
function* apiGateWayActionHandler(action) {
  try {
    const reply = yield call(apiGateWayHandler, action);
    yield put({ ...action, type: REDUX_API_GATEWAY_ACTIONS.API_GATEWAY_FETCHING_SUCCESS });
    yield put({ type: reply.successAction, payload: reply.res, args: { payload: action.payload, data: action.data } });
  } catch (reply) {
    yield put({ ...action, type: REDUX_API_GATEWAY_ACTIONS.API_GATEWAY_FETCHING_FAILURE });
    yield put({ type: reply.failureAction, payload: reply.err, args: { ...action.payload, ...action.args } });
  }
}

/**
 * Saga: Capture all API_SOCKET_EMIT actions and call method to handle side-effects
 */
export default function* takeEveryApiGateWaySaga() {
  yield takeEvery(REDUX_API_GATEWAY_ACTIONS.API_GATEWAY_FETCHING, apiGateWayActionHandler);
}



// WEBPACK FOOTER //
// ./src/saga/ApiGateWay/apiGateWaySaga.js